module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("hOtWz"))).then(() => parcelRequire('dWyK3'));